import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({

    selector: 'syn-dynamic-list-load-more',
    templateUrl: 'dynamic-list-load-more.component.html',
    styleUrls: ['dynamic-list-load-more.component.scss']
})
export class DynamicListLoadMoreComponent {
    @Input() loading: boolean;
    @Input() empty: boolean;
    @Input() active: boolean;
    @Input() allLoaded: boolean;

    @Input() textLoading = 'Chargement en cours';
    @Input() textEmpty = 'Aucun résultat';
    @Input() textLoadMore = 'Charger plus';
    @Input() textAllLoaded = 'Tous les élements ont été chargés';

    @Output() onLoadMore: EventEmitter<void> = new EventEmitter<void>();

    public loadMore() {
        this.onLoadMore.emit();
    }
}
